module.exports = __webpack_public_path__ + "img/3.aff0ba55.png";